import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { API } from "@/lib/api";

export default function InvoicePublic({ storeSlug }) {
  const params = useParams();
  const token = params.token;
  const slug = storeSlug || params.slug;
  const [inv, setInv] = useState(null);
  const [err, setErr] = useState("");

  const path = slug
    ? `/invoice-maker/public/${encodeURIComponent(slug)}/${encodeURIComponent(token || "")}`
    : `/invoice-maker/${encodeURIComponent(token || "")}`;

  useEffect(() => {
    if (!token) return;
    api.get(path).then(({ data }) => setInv(data)).catch(() => setErr("This invoice is not available."));
  }, [path, token]);

  if (err) return <div className="max-w-xl mx-auto p-10 text-slate-600" data-testid="bill-missing">{err}</div>;
  if (!inv) return <div className="p-10 text-slate-500">Loading invoice…</div>;

  return (
    <div className="min-h-screen bg-[#f4efe4]" data-testid="bill-public">
      <div className="max-w-[920px] mx-auto px-4 py-6">
        <div className="flex items-center justify-between gap-4 mb-4">
          <div>
            <div className="text-xs uppercase tracking-wide text-slate-500">{inv.brand?.brand_name || "Invoice"}</div>
            <h1 className="font-display text-2xl font-bold text-slate-900">{inv.number}</h1>
          </div>
          <a href={`${API}${path}/pdf`} data-testid="bill-pdf" className="inline-flex h-10 items-center rounded-full bg-slate-900 px-4 text-sm font-semibold text-white">Download PDF</a>
        </div>
        <img src={`${API}${path}/image`} alt={`${inv.number} invoice`} className="w-full bg-white shadow-lg" data-testid="bill-preview" />
      </div>
    </div>
  );
}
